import { Language } from '../../core/i18n/constants';
import { useLanguage } from '../../core/i18n/hooks/use-language';
import { BASE_BACKEND_QUERY_KEY, BASE_BACKEND_URL } from '../backend/constants';
import { QueryOptions, useAuthenticatedQuery } from '../backend/hooks/use-authenticated-query';
import { GetSelfUserResponse, GetUsersResponse } from '../backend/openapi/api-types';

const usersUrls = {
  getUsers: () => `${BASE_BACKEND_URL}/users` as const,
  getSelf: () => `${BASE_BACKEND_URL}/users/self` as const,
};

const usersQueryKeys = {
  users: (language: Language) => [BASE_BACKEND_QUERY_KEY, language, 'users'],
  self: (language: Language) => [BASE_BACKEND_QUERY_KEY, language, 'users', 'self'],
};

export const useSelfQuery = () => {
  const language = useLanguage();
  const queryOptions: QueryOptions<GetSelfUserResponse> = {
    options: {
      queryKey: usersQueryKeys.self(language),
    },
    url: usersUrls.getSelf(),
  };
  return useAuthenticatedQuery<GetSelfUserResponse>(queryOptions);
};

export const useUsersQuery = () => {
  const language = useLanguage();
  const queryOptions: QueryOptions<GetUsersResponse> = {
    options: {
      queryKey: usersQueryKeys.users(language),
    },
    url: usersUrls.getUsers(),
  };
  return useAuthenticatedQuery<GetUsersResponse>(queryOptions);
};
